"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Randomly selects tile indexes to have mines.
 */
function pureRNG(dimensions, numMines, rand) {
    var mines = [];
    while (mines.length < numMines) {
        var chosenTileIndex = Math.floor(rand() * dimensions.rows *
            dimensions.cols);
        if (!mines.includes(chosenTileIndex)) {
            mines.push(chosenTileIndex);
        }
    }
    return (mines);
}
exports.pureRNG = pureRNG;
//# sourceMappingURL=MineGenerators.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/utils/MineGenerators.js
// module id = 39
// module chunks = 0